import React from 'react'
import './styles.css'

import Tetris from './components/Tetris'
import { useState } from 'react'

export default function App() {
	const timepass = window.timepass
	const uid = timepass.getUserId()
	timepass.analytics.configureUserId(uid)
	timepass.analytics.initialize(
		'712b8c7fd0fd5b15b68cefdff3d330d3',
		'5a700cd8ea45406d274fbc2450551f743c6d9149'
	)
	return <Tetris />
}
